export class MobilePhlebotomyRequestConflictError extends Error {
  constructor(public readonly requestId: string) {
    super("A mobile phlebotomy request with different details already exists");
    this.name = "MobilePhlebotomyRequestConflictError";
  }
}
